import React from "react";
import KiotOrdersComponent from "./KiotOrdersComponent";


const KiotExportOrders = props => {
    return <KiotOrdersComponent tab={2} status={'1,5'} screenTitle={'Giao hàng cho khách hàng'}/>
};

export default KiotExportOrders;
